import BlocksContainer from "library/show/components/content/blocks/BlocksContainer"
import PropTypes from "prop-types"

const ContentMethodBlocks = function (props) {
  return (
    <div className="ContentMethod__Blocks">
      <BlocksContainer mode="edit" />
    </div>
  )
}

ContentMethodBlocks.displayName = "ContentMethodBlocks"

ContentMethodBlocks.propTypes = {
  config: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  minHeight: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

ContentMethodBlocks.defaultProps = {
  config: "advanced",
  placeholder: "Write or paste content...",
  minHeight: "300px"
}

export default ContentMethodBlocks
